import React from 'react';
import { Box } from '@mui/material';
import Header from './Header';
import Footer from './Footer';
import { Outlet } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const Layout = () => {
    const { isAuthenticated } = useAuth();

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
            <Header isAuthenticated={isAuthenticated} />
            <Box component="main" sx={{ flexGrow: 1 }}>
                {/* Outlet will render the matched child route component */}
                <Outlet />
            </Box>
            <Footer />
        </Box>
    );
};

export default Layout;